/* eslint-disable no-plusplus */
import React, { useEffect, useState, useMemo } from 'react';
import { CheckmarkAshIcon } from '@glu/icons-react';
import PropTypes from 'prop-types';

let uniqueId = 0;

const Checkbox = (props) => {
  const {
    checked,
    classes,
    disabled,
    htmlId,
    htmlValue,
    labelText,
    name,
    onChange,
    onKeyDown,
    dataQa,
    value: fieldValue
  } = props;

  // eslint-disable-next-line no-plusplus
  const [isSelected, setIsSelected] = useState(checked ? true : htmlValue === fieldValue);

  useEffect(() => {
    setIsSelected(checked ? true : htmlValue === fieldValue);
  }, [checked, fieldValue, htmlValue, isSelected]);

  const handleChange = ({ target: { checked: newChecked } }) => {
    setIsSelected(newChecked);
    onChange(name, newChecked ? htmlValue : newChecked);
  };

  const id = useMemo(() => `${htmlId}-checkbox-radio-${uniqueId++}`, [htmlId]);
  return (
    <label
      className={`${classes.checkboxRoot} ${disabled ? classes.checkboxDisabled : ''}`}
      title={typeof labelText === 'string' ? labelText : labelText.props?.string}
      htmlFor={id}
    >
      <input
        id={id}
        type="checkbox"
        checked={isSelected}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        value={htmlValue}
        name={name}
        disabled={disabled}
        data-qa={dataQa}
      />
      <div className={`${classes.checkboxIcon} ${isSelected ? classes.checkboxSelected : ''} `}>
        {isSelected && <CheckmarkAshIcon />}
      </div>
      <span className={classes.checkboxLabelText}>{labelText}</span>
    </label>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  classes: PropTypes.shape({
    checkboxRoot: PropTypes.string.isRequired,
    checkboxIcon: PropTypes.string.isRequired,
    checkboxSelected: PropTypes.string.isRequired,
    checkboxDisabled: PropTypes.string.isRequired,
    checkboxLabelText: PropTypes.string.isRequired
  }),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  htmlId: PropTypes.string,
  htmlValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  dataQa: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number])
};
Checkbox.defaultProps = {
  classes: {
    checkboxRoot: '',
    checkboxIcon: '',
    checkboxSelected: '',
    checkboxDisabled: ''
  },
  checked: false,
  disabled: false,
  htmlId: undefined,
  htmlValue: true,
  labelText: undefined,
  name: '',
  onChange: undefined,
  onKeyDown: undefined,
  dataQa: '',
  value: false
};
